import * as React from 'react';
import { useReducer, useEffect, useRef, useContext } from 'react';

import { AppUserInfo, UserProfile } from "../../models/index";
import { UserAdministrativeException } from '../../models/UserAdministrativeException';
import UserAdministrativeExceptionService from '../../services/UserAdministrativeExceptionService';
import AuthenticationContext from '../../components/context/AuthenticationContext';
import { Button } from 'reactstrap';


const PAGE_SIZE = 10;

type AEState = {
    aeData: UserAdministrativeException
}

export const AEDashboard = (props: {
    userProfile?: UserProfile
}) => {

    const authCtx = useContext(AuthenticationContext);

    let [state, setState] = useReducer(
        (prevState: AEState, newState: Partial<AEState>) => ({ ...prevState, ...newState }),
        {
            aeData: new UserAdministrativeException()
        }
    );

    const getAEs = async () => {

        let ae = await UserAdministrativeExceptionService.get();
        if (props.userProfile) {
            ae = await UserAdministrativeExceptionService.getAE(props.userProfile.userProfileId);
        }

        if (ae) {
            setState({
                aeData: ae.value
            })
            console.log('AE IS', ae);
        }
    }

    useEffect(() => {
        getAEs();
    }, []);

    return <div className="mb-4">
        {state.aeData && state.aeData.administrativeException != null &&
            <div className="border border-2 rounded p-2 mt-4">
                <h3>Administrative Exceptions</h3>
                <div className="mt-2">
                    <div>AE Status 1: <strong>{state.aeData.administrativeException}</strong></div>
                    AE Decision Letter 1:<br />
                    {state.aeData.userLetter1 && <em dangerouslySetInnerHTML={{ __html: state.aeData.userLetter1.replace(/(?:\r\n|\r|\n)/g, '<br>') || '' }}></em>}
                </div>

                {state.aeData.hasAE2 &&
                    <div className="mt-2">
                        <div>AE Status 2: <strong>{state.aeData.administrativeException2}</strong></div>
                        AE Decision Letter 2:<br />
                        {state.aeData.userLetter2 && <em dangerouslySetInnerHTML={{ __html: state.aeData.userLetter2.replace(/(?:\r\n|\r|\n)/g, '<br>') || '' }}></em>}
                    </div>
                }

                {state.aeData.hasAE3 &&
                    <div className="mt-2">
                        <div>AE Status 3: <strong>{state.aeData.administrativeException3}</strong></div>
                        AE Decision Letter 3:<br />
                        {state.aeData.userLetter3 && <em dangerouslySetInnerHTML={{ __html: state.aeData.userLetter3.replace(/(?:\r\n|\r|\n)/g, '<br>') || '' }}></em>}
                    </div>
                }
            </div>
        }
    </div>
};